import * as React from 'react';

const SvgBell = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.12}
      d="M7.82824 14.6641C8.90914 14.6641 9.78538 13.7686 9.78538 12.6641H5.87109C5.87109 13.7686 6.74734 14.6641 7.82824 14.6641Z"
      fill="#0E0C0F"
    />
    <path
      d="M9.78527 12.6693C9.78527 13.7738 8.90902 14.6693 7.82812 14.6693C6.74722 14.6693 5.87098 13.7738 5.87098 12.6693M9.00013 4.16164C9.28424 3.8617 9.45908 3.45302 9.45908 3.0026C9.45908 2.08213 8.72887 1.33594 7.82812 1.33594C6.92737 1.33594 6.19717 2.08213 6.19717 3.0026C6.19717 3.45302 6.37201 3.8617 6.65612 4.16164M11.7424 7.46927C11.7424 6.54985 11.33 5.66809 10.5959 5.01797C9.86187 4.36784 8.86626 4.0026 7.82812 4.0026C6.78999 4.0026 5.79438 4.36784 5.06031 5.01797C4.32623 5.66809 3.91384 6.54985 3.91384 7.46927C3.91384 8.99047 3.54468 10.103 3.08405 10.8991C2.55906 11.8064 2.29657 12.26 2.30694 12.3684C2.3188 12.4923 2.34063 12.5315 2.43903 12.605C2.52503 12.6693 2.95713 12.6693 3.82132 12.6693H11.8349C12.6991 12.6693 13.1312 12.6693 13.2172 12.605C13.3156 12.5315 13.3375 12.4923 13.3493 12.3684C13.3597 12.26 13.0972 11.8064 12.5722 10.8991C12.1116 10.103 11.7424 8.99047 11.7424 7.46927Z"
      stroke="#0E0C0F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgBell;
